<template>
    <div>
        <h2 class="col-lg-12 text-center mb-3">{{ $t('edit') }}</h2>
        <PaletteForm :basePalette="palette" :basepaletteName="name" :loading="loading" @submit-requested="submitRequested"></PaletteForm>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex'
    import PaletteForm from './PaletteForm.vue'
    import router from '@/router';

    export default {
        data() {
            return {
                palette: null,
                name: this.$route.params.name,
                loading: true
            }
        },
        components: { PaletteForm },
        computed:
        {
            ...mapState('palettes', ['getPaletteByIdOutput']),
        },
        methods: {
            ...mapActions('palettes', ['getPaletteById']),
            ...mapActions('palettes', ['putPalette']),
            submitRequested(palette) {
                this.putPalette(palette);
            },
        },
        mounted: function () {
            if (!this.$route.query.id) {
                router.push({name: "PalettesList"});
            }
            else {
                this.getPaletteById(this.$route.query.id);
            }
        },
        watch:
        {
            getPaletteByIdOutput: function (output) {
                if (!output && !output.data) {
                    router.push({name: "PalettesList"});
                }
                else {
                    this.palette = output.data;
                    this.loading = false;
                }
            }
        }
    }
</script>